import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { resolveImageUrl } from "@/lib/media";
import { PageHeader } from "@/components/PageHeader";
import { Reveal } from "@/components/Reveal";
import { SEO } from "@/components/SEO";

export default function Programs() {
  const [content, setContent] = useState(null);

  useEffect(() => {
    api.get("/content/programs").then((res) => setContent(res.data));
  }, []);

  if (!content) return <div className="pt-40 pb-24 text-center text-muted-foreground">Loading…</div>;

  return (
    <div data-testid="programs-page">
      <SEO
        title="Our Programs"
        description="Explore PhysioAbhi's physiotherapy programs for elderly care, special needs children, and underserved athlete rehabilitation in Bengaluru."
        path="/programs"
      />
      <PageHeader eyebrow={content.eyebrow} title={content.title} subtitle={content.subtitle} />
      <section className="px-5 md:px-10 py-8">
        <div className="max-w-6xl mx-auto space-y-4">
          {content.programs.map((p, i) => (
            <Reveal key={p.num} delay={i * 0.08}>
              <div
                data-testid={`program-block-${p.num}`}
                className={`grid grid-cols-1 md:grid-cols-2 gap-0 border border-border ${i % 2 === 1 ? "md:[direction:rtl]" : ""}`}
              >
                <div className="aspect-[4/3] md:aspect-auto overflow-hidden">
                  <img src={resolveImageUrl(p.img)} alt={p.title} className="w-full h-full object-cover" />
                </div>
                <div className="p-8 md:p-14 flex flex-col justify-center [direction:ltr]">
                  <span className="font-heading text-5xl text-accent/90">{p.num}</span>
                  <h3 className="font-heading text-2xl md:text-3xl mt-4 mb-6">{p.title}</h3>
                  <ul className="space-y-3">
                    {p.points.map((pt) => (
                      <li key={pt} className="text-muted-foreground text-sm md:text-base flex gap-3">
                        <span className="text-accent">—</span>{pt}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
